export default __webpack_public_path__ + "static/media/topicNewIconClicked.95d17133.svg";